(() => {
  if (window.kindraEnquirySubscriptionInitialized || window.Shopify?.designMode) return;
  const config = document.querySelector('[data-kindra-enquiry-config]');
  const panel = document.querySelector('[data-enquiry-subscription-panel]');
  const signup = document.getElementById('KindraEnquirySubscription');
  if (!config || !panel || !signup) return;
  window.kindraEnquirySubscriptionInitialized = true;
  const preview = config.dataset.preview === 'true' || window.Shopify?.theme?.role !== 'main';
  const key = `kindra.enquiry.signup.v1.${preview ? 'draft' : 'live'}`;
  const maxAge = 30 * 60 * 1000;
  const parameter = 'kindra_enquiry_signup';
  let starting = false;
  const clear = () => { try { sessionStorage.removeItem(key); } catch {} };
  const save = record => { try { sessionStorage.setItem(key, JSON.stringify(record)); return true; } catch { return false; } };
  function read() {
    try {
      const record = JSON.parse(sessionStorage.getItem(key));
      if (!record) return null;
      if (!record.created || Date.now() - record.created > maxAge || record.created > Date.now() || !['contact', 'delivery_quote'].includes(record.type)) { clear(); return null; }
      return record;
    } catch { return null; }
  }
  function localURL(path) {
    const url = new URL(path, location.origin);
    if (url.origin !== location.origin) throw new Error('Invalid enquiry destination');
    return url;
  }
  const relative = url => url.pathname + url.search + url.hash;
  function field(form, name, value) {
    let input = form.elements.namedItem(name);
    if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.append(input); }
    input.value = value;
  }
  function populate(record) {
    field(signup, 'contact[email]', record.email);
    const [first = '', ...last] = record.name.trim().split(/\s+/);
    field(signup, 'contact[first_name]', first);
    field(signup, 'contact[last_name]', last.join(' '));
    field(signup, 'contact[tags]', `kindra-enquiry,kindra-informational-follow-up,kindra-consent-v1,kindra-enquiry-${record.type.replace('_', '-')}`);
    const finish = localURL(record.finish);
    finish.searchParams.set(parameter, record.token);
    field(signup, 'return_to', relative(finish));
    panel.querySelector('[data-enquiry-subscription-continue]').href = record.finish;
  }
  function reveal(record) {
    populate(record);
    document.getElementById(record.formId)?.closest('dialog')?.close();
    panel.hidden = false;
    if (!panel.dataset.focused) { panel.dataset.focused = 'true'; panel.scrollIntoView({ block: 'center' }); }
  }
  function start(record) {
    if (starting) return;
    starting = true;
    populate(record);
    record.phase = 'submitting';
    if (!save(record)) { reveal(record); return; }
    let submitted = false;
    const fallback = setTimeout(() => reveal(record), 8000);
    const submit = () => {
      if (submitted) return;
      submitted = true;
      try { signup.submit(); } catch { clearTimeout(fallback); reveal(record); }
    };
    try {
      if (window.Shopify?.captcha?.protect) window.Shopify.captcha.protect(signup, submit);
      else submit();
    } catch { clearTimeout(fallback); reveal(record); }
  }
  function init() {
    const record = read();
    if (!record) return;
    const url = new URL(location.href);
    const finish = localURL(record.finish);
    if (record.phase === 'submitting' && url.pathname === finish.pathname && url.searchParams.get(parameter) === record.token) {
      clear();
      url.searchParams.delete(parameter);
      history.replaceState(history.state, '', relative(url));
      return;
    }
    if (record.phase === 'submitting') {
      if (location.pathname === record.source || signup.querySelector('[data-enquiry-subscription-errors]').dataset.enquirySubscriptionErrors === 'true') reveal(record);
      return;
    }
    if (location.pathname !== record.source || location.hash !== '#' + record.formId) return;
    const marker = Array.from(document.querySelectorAll('[data-kindra-enquiry]')).find(el => el.closest('form')?.id === record.formId);
    if (marker?.dataset.success === 'true' && marker.dataset.errors !== 'true') start(record);
  }
  function bind() {
    document.querySelectorAll('[data-kindra-enquiry]').forEach(marker => {
      const form = marker.closest('form');
      if (!form || form.dataset.enquirySignupBound) return;
      form.dataset.enquirySignupBound = 'true';
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        const type = marker.dataset.kindraEnquiry;
        if (!['contact', 'delivery_quote'].includes(type)) return;
        const email = form.elements.namedItem('contact[email]')?.value.trim();
        if (!email) return;
        const source = new URL(location.pathname, location.origin);
        const previewId = new URLSearchParams(location.search).get('preview_theme_id');
        if (preview && previewId) source.searchParams.set('preview_theme_id', previewId);
        source.searchParams.set('contact_posted', 'true');
        source.hash = form.id;
        const finish = type === 'contact' ? localURL(form.elements.namedItem('return_to')?.value || config.dataset.contactSuccessUrl) : new URL(source);
        const record = { created: Date.now(), token: crypto.randomUUID(), phase: 'pending', type, formId: form.id, source: location.pathname, finish: relative(finish), email, name: (form.elements.namedItem('contact[name]')?.value || '').slice(0, 150) };
        if (!save(record)) return;
        field(form, 'return_to', relative(source));
      }, true);
    });
  }
  signup.addEventListener('submit', () => {
    const record = read();
    if (record) { record.phase = 'submitting'; save(record); }
  });
  panel.querySelector('[data-enquiry-subscription-continue]').addEventListener('click', clear);
  bind();
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init, { once: true });
  window.addEventListener('pageshow', event => { if (event.persisted) { starting = false; init(); } });
  document.addEventListener('shopify:section:load', bind);
})();
